import React from "react";
import { Toaster } from "react-hot-toast";

export const CustomToaster = () => {
  return (
    <Toaster
      gutter={18}
      toastOptions={{
        style: {
          borderRadius: "8px",
          backgroundColor: "#222222",
          justifyContent: "flex-start",
          backgroundRepeat: "no-repeat",
          padding: "20px",
          color: "white",
          fontWeight: "700",
          textAlign: "center",
          fontSize: "16px",
          lineHeight: "120%",
          boxShadow: "rgba(0, 0, 0, 0.2)",
          width: "300px",
          height: "56px",
        },
        success: {
          icon: (
            <img
              src="/toast/toast-success.svg"
              alt="Success"
              width={32}
              height={32}
            />
          ),
          style: {
            backgroundImage: 'url("/toast/background-success-toast.svg")',
          },
        },
        error: {
          icon: (
            <img
              src="/toast/toast-error.svg"
              alt="Error"
              width={32}
              height={32}
            />
          ),
          style: {
            backgroundImage: 'url("/toast/bg-toast-error.svg")',
          },
        },
      }}
    />
  );
};
